// src/components/ScrollToTop.jsx
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  // Disable browser automatic restoration (one-time)
  useLayoutEffect(() => {
    if ('scrollRestoration' in window.history) {
      try {
        window.history.scrollRestoration = 'manual';
      } catch (e) {
        // ignore in strict envs
      }
    }
  }, []);

  // Scroll to top immediately when pathname changes (useLayoutEffect for no flicker)
  useLayoutEffect(() => {
    // If an element was auto-focused, blur it to avoid scroll jumps
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }

    // force immediate top
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

    // sometimes tiny layout shifts happen after render — a micro timeout is safe
    const t = setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0);
    }, 50);

    return () => clearTimeout(t);
  }, [pathname]);

  return null;
}
